export default "__VITE_ASSET__5559f974__"